import { OrderMethod } from '../../../../../services/exports/Constants';

export default {
  [OrderMethod.Pickup]: 'Afhalen',
  [OrderMethod.Delivery]: 'Bezorging',
  [OrderMethod.OnSite]: 'Ter plaatse',
};
